import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import Button from "../../components/shared/button/component";
import FacebookLogin from "react-facebook-login";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { getFacebookClientId } from "../../utils/general-config";
import PSRRightSideSU from "./PSReskining/pSRRightSideSU.js";
import Footer from "../../components/footer/component.js";
const SignSimpliSignUp = ({
  onSignUp,
  navigateSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  emailError,
  errorCount,
  emailErrorMsg,
  passwordError,
  passwordErrorMsg,
  loginError,
  loginErrorMessage,
  onEmailChangeHandler,
  onPwdChangeHandler,
  onPasswordKeyPress,
  emailId,
  pwd,
  termsOfUse,
  privacyPolicy,
  appleLogin,
  pwdNavigate,
  signUpNavigate
}) => {
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;

  return (
    <>
       <Helmet>
        <meta name="description" content={t("sign_up.ss.description_meta")} />
        <title>{t("page_title.ss.sign_up")}</title>
      </Helmet>{" "}
      <section className="main-content !min-h-[calc(100vh-11rem)] min-[1400px]:!pt-0 backdrop-blur-[100px] bg-blur-bg-rs !font-rethink">
        <div className="flex justify-center items-center flex-col">
          <div className="container   min-[1000px]:!pb-[1.5rem] min-[1400px]:!pb-0 mx-auto">
            <div className="flex w-full justify-center items-center flex-col md:flex-row gap-x-12">
              <div className="w-full md:w-2/5 order-2 md:order-none lg:max-w-[400px] lg:h-[450px]">
                <div className="font-bold text-[24px] text-center align-middle flex justify-center max-[550px]:my-[20px] -mt-9 lowercase text-[#16283D]">
                  {t("sign_up.safe_and_secure")}
                </div>
                <div className="w-full h-full lg:h-auto flex items-center justify-center">
                  <img
                    src="/app/account/static/images/pdfsimpli-convert.svg"
                    className="w-full h-full lg:h-auto  object-contain"
                  />
                </div>

                <span className="hidden md:flex items-center justify-center">
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/worksimpli/review-new-icon.svg"}
                    className="block"
                  ></img>
                </span>
              </div>
              <div className="w-full lg:w-2/5  md:w-3/5  min-[1400px]:w-[48.5%] order-1 md:order-none min-[1400px]:py-[40px] min-[1400px]:px-[60px]">
                <PSRRightSideSU
                  pwdNavigate={pwdNavigate}
                  signUpNavigate={signUpNavigate}
                  onSignUp={onSignUp}
                  disableBtn={disableBtn}
                  responseFacebook={responseFacebook}
                  googleLogin={googleLogin}
                  passwordError={passwordError}
                  emailError={emailError}
                  passwordErrorMsg={passwordErrorMsg}
                  onEmailChangeHandler={onEmailChangeHandler}
                  emailId={emailId}
                  onPwdChangeHandler={onPwdChangeHandler}
                  onPasswordKeyPress={onPasswordKeyPress}
                  pwd={pwd}
                  appleLogin={appleLogin}
                  termsOfUse={termsOfUse}
                  privacyPolicy={privacyPolicy}
                  loginErrorMessage={loginErrorMessage}
                  emailErrorMsg={emailErrorMsg}
                  loginError={loginError}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default SignSimpliSignUp;
